import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useAdminContext } from "../../context/adminContext";

function withRouter(Component) {
  const Wrapper = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const { admin } = useAdminContext();

    return (
      <Component
        router={{ navigate: navigate, location: location, params: params }}
        admin={admin}
        {...props}
      />
    );
  };

  return Wrapper;
}

export default withRouter;
